import React from "react";
import { connect } from "react-redux";
import Axios from "axios";
import { sourceTypes } from "../../constants/cms/sourceType";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Row, Label, Col, Input, FormGroup } from "reactstrap";
import { InputBase, Paper, Button, Tooltip } from "@material-ui/core";
import JirangoSwitch from "../JirangoSwitch/JirangoSwitch";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import LinkIcon from "@material-ui/icons/Link";
import ViewListIcon from "@material-ui/icons/ViewList";
import { FloatingGenericList } from "../FloatingChecklist/FloatingChecklist";
import { cmsActions } from "../../store/actions/cms/cms.action";

class LinkManager extends React.Component {
  state = {
    showSettings: false,
    internalPaths: [],
    searchKey: "",
    currentLink: this.props.url || "",
    domain: "",
    target: "_blank",
    appendBadgeNo: false,
    showList: false,
  };
  componentDidMount() {
    const { selectedLink } = this.props;
    if (selectedLink && typeof selectedLink == {}) {
      const { target, link, name } = selectedLink;
      this.setState({ target, currentLink: link, displayText: name });
    }
    this.getInternalPaths();
  }
  componentDidUpdate(prevProps) {
    const { selectedLink } = this.props;
    if ((selectedLink && !prevProps.selectedLink) || (selectedLink && prevProps.selectedLink != selectedLink)) {
      const { target, link, name } = selectedLink;
      this.setState({ target, currentLink: link, displayText: name });
    }
    if (this.props.isOpen && !prevProps.isOpen) {
      this.props.dispatch(cmsActions.blockDeselect(true));
    }
  }

  editLink = (e) => this.setState({ currentLink: e });
  search = (str) => this.setState({ searchKey: str, showList: false });
  toggleAlt = () => this.setState({ target: this.state.target == "_blank" ? "_self" : "_blank" });
  handleClose = () => {
    this.props.toggle();
    setTimeout(() => this.props.dispatch(cmsActions.blockDeselect(false)), 2000);
  };
  setLink = () => {
    const { displayText, target, domain, currentLink } = this.state;
    this.props.setLink(
      currentLink /* {
      currentLink,
      displayText,
      target,
    } */
    );
    this.props.toggle();
  };
  getInternalPaths = () => {
    const { eventId } = this.props;
    if (!eventId) return;
    Axios.get(`./api/link/${eventId}`).then((res) => {
      const { data } = res;
      if (data) {
        const { pathsObj } = data;
        this.setState({
          internalPaths: pathsObj.paths,
          domain: pathsObj.domain,
        });
      }
    });
  };
  convertInternalLink = (type, id) => {
    const { domain } = this.state;
    switch (type) {
      case "AnonymousSurvey":
        if (typeof id === "string" && !isNaN(id)) id = parseInt(id);
        return domain + "/cms/survey/" + id.toString(36);
      case "Form":
        if (typeof id === "string" && !isNaN(id)) id = parseInt(id);

        return domain + "/cms/register/" + id.toString(36) + "?badgeNo=[clientKey]";
      case "Breakout":
        return domain + "/interaction/digitalarena/" + id + "?clientKey=[clientKey]";
      case "Page":
        if (typeof id === "string" && !isNaN(id)) id = parseInt(id);
        return domain + "/cms/p/" + id.toString(36) + "?badgeNo=[clientKey]";
      case "DigitalArena":
        return domain + "/interaction/digitalarena/" + id + "?clientKey=[clientKey]";
      case "Cms2FORM":
      case "Cms2PAGE":
      case "Cms2SURVEY":
        return domain + (!window.location.href.includes("localhost") ? "/cms" : "") + "/web/" + id + "?badgeNo=[clientKey]";
      default:
        return "";
    }
  };
  selectFromList = (id) => {
    const { internalPaths } = this.state;
    const internalPath = internalPaths.find((p) => p.id == id);
    if (internalPath) {
      this.setState({
        currentLink: this.convertInternalLink(internalPath.type, id),
        displayText: internalPath.name,
        searchKey: false,
        /*         showList: false, */
      });
    }
  };

  toggleMailTo = () => {
    if (this.state.currentLink && this.state.currentLink.includes("mailto:")) {
      this.setState({ currentLink: this.state.currentLink ? this.state.currentLink.replace("mailto:", "") : "" });
    } else {
      this.setState({ currentLink: "mailto:" + this.state.currentLink });
    }
  };

  render() {
    const { isOpen } = this.props;
    const { searchKey, internalPaths, showList, displayText, currentLink } = this.state;
    return (
      <Dialog open={isOpen} fullWidth={true} maxWidth={"sm"} onClose={this.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogContent className="dark-l2 " style={{ overflowY: "visible" }}>
          <Row>
            <Col>
              <Label className="primary-text">
                <SystemLabel name="Link" />
              </Label>
            </Col>
          </Row>
          <Row>
            <Col style={{ width: "100%", display: "flex", alignItems: "center" }}>
              <div style={{ background: "#3f414c", width: "100%" }}>
                <InputBase
                  className="dark-l2 dark-input pl-14"
                  style={{
                    flex: 1,
                    color: "#5c6873",
                    fontSize: "14px",
                    width: "100%",
                    border: 0,
                  }}
                  value={this.state.currentLink || this.props.url}
                  placeholder={"Url"}
                  inputProps={{ "aria-label": "search clients" }}
                  onChange={(e) => {
                    this.search(e.target.value);
                    this.editLink(e.target.value);
                  }}
                />
              </div>
              <div onClick={() => this.setState({ showList: !this.state.showList })} style={{ padding: "0px 10px", cursor: "pointer", zIndex: 1 }} aria-label="search">
                <Tooltip title={<SystemLabel name="PagesInJirango" />}>
                  <ViewListIcon style={{ color: showList ? " #0da2cd" : "#737373" }} />
                </Tooltip>
              </div>
            </Col>
          </Row>
          {showList && internalPaths.length > 0 ? (
            <>
              <br />
              <Row>
                <Col>
                  <Label className="primary-text">
                    <SystemLabel name="PagesInJirango" />
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{ color: "#ffff", background: "#303139", padding: "10px", marginTop: 5, borderRadius: 5 }}>
                    <FloatingGenericList
                      onCheck={(id) => this.selectFromList(id)}
                      list={showList ? internalPaths : internalPaths.filter((p) => p.name.toLowerCase().includes(searchKey.toLowerCase()))}
                    />
                  </div>
                </Col>
              </Row>
            </>
          ) : null}
          <br />
          <Row>
            <Col>
              <Label className="primary-text">
                <SystemLabel name="MailLink" />
              </Label>
            </Col>
          </Row>
          <Row style={{ width: 70 }}>
            <Col className="text-left">
              <JirangoSwitch onChange={() => this.toggleMailTo()} isChecked={this.state.currentLink ? this.state.currentLink.includes("mailto:") : false} />
            </Col>
          </Row>
        </DialogContent>
        <DialogActions className="dark-l2 ">
          <Button onClick={this.props.toggle} className="secondary-text">
            <SystemLabel name="Cancel" />
          </Button>
          <Button onClick={this.setLink} className="primary-text" autoFocus>
            <SystemLabel name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let eventId = null;
  if (enviroment === sourceTypes.FORM) {
    eventId = state.form.eventId;
  }
  if (enviroment === sourceTypes.PAGE) {
    eventId = state.page.eventId;
  }
  if (enviroment === sourceTypes.TEMPLATE) {
    eventId = state.template.eventId;
  }

  if (enviroment === sourceTypes.EMAIL) {
    eventId = state.email.eventId;
  }
  return {
    template: state.template.template,
    cms: state.cms,
    /*     eventId, */
  };
}
export default connect(mapStateToProps)(LinkManager);
